export enum MemberStatus {
    NonMember = 0,
    Prospect = 1,
    Pending = 2,
    Current = 3,
    GracePeriod = 4,
    Expired = 5,
    Inheriting = 6
}